import {
  ModalsProvider,
  NotificationsProvider,
  ThemeProvider as ThemeProviderNext,
} from '@inflearn/ds-react-next';
import type { ReactNode } from 'react';

import { NEXT_PUBLIC_CDN_URL } from '../../appConfig';
import { styleCacheNext } from '../utils/emotionCache';

export function DsProvider({ children }: { children: ReactNode }) {
  return (
    <ThemeProviderNext cdnLink={NEXT_PUBLIC_CDN_URL || ''} emotionCache={styleCacheNext}>
      <NotificationsProvider />
      <ModalsProvider>{children}</ModalsProvider>
    </ThemeProviderNext>
  );
}
